import { BaseInstrumentation, VERSION } from '@grafana/faro-web-sdk';
import { setDependencies } from './dependencies';
import { initializeReactRouterInstrumentation } from './router';
export class ReactIntegration extends BaseInstrumentation {
    constructor(options = {}) {
        super();
        this.options = options;
        this.name = '@grafana/faro-react';
        this.version = VERSION;
    }
    initialize() {
        setDependencies(this.internalLogger, this.api);
        initializeReactRouterInstrumentation(this.options);
    }
}
//# sourceMappingURL=instrumentation.js.map